import resetStore from '@/helpers/reset-store';
import axios from 'axios';

export const state = () => ({
  products: [],
  items: [],
  savedBaskets: [],
  loading: false,
  initialized: false
});

export const mutations = {
  RESET_STORE: resetStore(state),
  SET_LOADING(state, loading) {
    state.loading = loading;
  },
  SET_INITIALIZED(state, initialized) {
    state.initialized = initialized;
  },
  SET_SAVED_BASKETS(state, baskets) {
    state.savedBaskets = baskets;
    state.initialized = true;
    state.loading = false;
  },
  UPDATE_BASKET_NAME(state, { basketID, basketName }) {
    const basket = state.savedBaskets.find(b => b.id === basketID);
    if (basket) basket.basket_name = basketName;
  },
  DELETE_BASKET(state, basketID) {
    state.savedBaskets = state.savedBaskets.filter(b => b.id !== basketID);
  },
  UPDATE_CHECKED_BASKET(state, basketID) {
    const basket = state.savedBaskets.find(b => b.id === basketID);
    if (basket) basket.checked_out = 0;
  }
};

export const getters = {
  products: state => state.products,
  items: state => state.items,
  savedBaskets: state => state.savedBaskets,
  loading: state => state.loading,
  initialized: state => state.initialized
};

export const actions = {
  async fetchBaskets({ commit }, justBaskets = false) {
    commit('SET_LOADING', true);
    try {
      const response = await axios.get('/api/saved-basket', {
        params: {
          justBaskets,
          includeBudget: true
        }
      });
      const baskets = response.data.data || response.data; // Adjust according to your API response
      commit('SET_SAVED_BASKETS', baskets);
    } catch (error) {
      console.error('Error fetching baskets:', error);
      commit('SET_LOADING', false);
      commit('SET_INITIALIZED', true);
    }
  },
  async addNewSavedBasket({ commit }, { basketData, newBasketName }) {
    try {
      const { data } = await axios.post('/api/saved-basket', { items: basketData, newBasketName });
      commit('SET_SAVED_BASKETS', data);
    } catch (error) {
      console.error('Error adding new basket:', error);
    }
  },

async approveAndMoveToBasket({ commit, dispatch }, savedBasket) {

  try {
    await dispatch('basket/removeBasket', 'stock', { root: true });
    if (savedBasket.address_id) {
      commit('basket/SET_APPROVED_ORDER_ADDRESS_ID', savedBasket.address_id, { root: true });
          const details = {
      poNumber: savedBasket.saved_ponumber,
      costCentre: savedBasket.saved_costcentre,
      notes: savedBasket.saved_notes,
      fao: savedBasket.saved_faofield,
      mobile: savedBasket.saved_mobile
    };
    commit('basket/SET_APPROVED_ORDER_DETAILS', details, { root: true });
    } else {
      console.error('[Vuex Action] ERROR: The savedBasket object passed to this action is missing the address_id field!');
    }

    const addPromises = savedBasket.itemsArray.map(item => {
      const basketObject = {
        parentId: item.parent?.internalId || item.internalId,
        price: parseFloat(item.price),
        productId: item.internalId,
        qty: item.qty
      };
      return dispatch('basket/addToBasket', basketObject, { root: true });
    });
    await Promise.all(addPromises);
    commit('basket/SET_BASKET_ID_TO_APPROVE', savedBasket.id, { root: true });

    // 4. Mark the saved basket as "approved" on the backend
    // await axios.patch(`/api/saved-basket/${savedBasket.id}`, {
    //   punchout_approved: 1
    // });
    
    return { success: true };
  } catch (error) {
    console.error("Error during basket approval:", error);
    return { success: false, error };
  }
},
  async loadBasketForCheckout({ dispatch, commit }, savedBasket) {
    try {
      await dispatch('basket/removeBasket', 'stock', { root: true });

      const addPromises = savedBasket.itemsArray.map(item => {
        const basketObject = {
          parentId: item.parent?.internalId || item.internalId,
          price: parseFloat(item.price),
          productId: item.internalId,
          qty: item.qty,
          name: item.name,
          thumbnail: item.thumbnail
        };
        return dispatch('basket/addToBasket', basketObject, { root: true });
      });
      await Promise.all(addPromises);

      commit('basket/SET_BASKET_ID_TO_APPROVE', savedBasket.id, { root: true });
      
      return { success: true };
    } catch (error) {
      console.error("Error loading basket for checkout:", error);
      return { success: false, error };
    }
  },
  async deleteBasket({ commit }, basketID) {
    try {
      await axios.patch('/api/saved-basket', { deleteBasket: true, basketID });
      commit('DELETE_BASKET', basketID);
    } catch (error) {
      console.error('Error deleting basket:', error);
    }
  },

  async updateCheckedOutBasket({ commit }, basketID) {
    try {
      await axios.patch('/api/saved-basket', { basket: basketID, checked_out: 1 });
      commit('RESET_STORE');
    } catch (error) {
      console.error('Error updating basket status:', error);
    }
  },

  async updatePrice({ commit }, { basket, productId }) {
    try {
      const { data } = await axios.patch('/api/saved-basket', { basket_id: basket, item_id: productId });
      commit('SET_SAVED_BASKETS', data);
    } catch (error) {
      console.error('Error updating price:', error);
    }
  },

  async removeFromSavedBasket({ commit }, { basket, productId }) {
    try {
      await axios.patch('/api/saved-basket', { basket_id: basket, item_id: productId, delete_from_saved: true });
      // Don't commit here - let the caller fetch fresh data like variant update does
    } catch (error) {
      console.error('Error removing item from basket:', error);
      throw error; // Re-throw so caller knows it failed
    }
  },

  async updateQuantity({ commit }, { basket, productId, qty }) {
    try {
      const { data } = await axios.patch('/api/saved-basket', { 
        basket_id: basket, 
        item_id: productId, 
        qty: qty 
      });
      commit('SET_SAVED_BASKETS', data);
    } catch (error) {
      console.error('Error updating quantity:', error);
      throw error;
    }
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
